import { CreditCardIcon } from "lucide-react";

function PaymentMethods() {
  return (
    <>
      <p className="font-bold">Mode de paiement</p>
      <div className="flex select-none items-center gap-2 rounded-lg border px-4 py-3">
        <CreditCardIcon width={20} height={20} />
        <span className="text-sm">Carte bancaire</span>
      </div>
    </>
  );
}

export default PaymentMethods;
